import { Grid2 as Grid } from '@mui/material';
import { BoxWithHeader } from '../common';
import { Accident } from '../types/accident';
import { AccidentDetail } from './AccidentDetail';
import { AccidentItem } from './AccidentItem';
import { AccidentsPhotos } from './AccidentsPhotos';

export const AccidentCustomerContent = (accident: Accident) => (
  <Grid container spacing={2}>
    <Grid size={{ xs: 12, lg: 6, xl: 4 }}>
      <AccidentItem {...accident} />
    </Grid>
    {/*<Grid size={{ xs: 12, lg: 6, xl: 8 }}>
      <BoxWithHeader title="Dokumenty k nehodě">
        <Stack gap={2}>
          <Stack>
            {accident?.media?.files?.map((file, idx) => (
              <DocumentItem key={idx} title={file.label} uploadAvailable={false} {...file} />
            ))}
            <DocumentItem title="Smlouva k nehodě"  />
            <DocumentItem title="Smlouva k nehodě" />
          </Stack>
        </Stack>
      </BoxWithHeader>
    </Grid>*/}
    {/*<Grid size={{ xs: 12, lg: 6, xl: 4 }}>
      <BoxWithHeader title="Průběh">
        <Stack gap={1}>
          <CheckItem checked label="Nehoda vytvořena" />
          <CheckItem checked label="Auto je v servise" />
          <CheckItem checked label="Pracuje se na lakování" />
          <CheckItem label="Kontrola a čištění vozu" />
          <CheckItem label="Předáno klientovi" />
        </Stack>
      </BoxWithHeader>
    </Grid>*/}
    <Grid size={12}>
      <BoxWithHeader title="Detaily k nehodě">
        <AccidentDetail accident={accident} />
      </BoxWithHeader>
    </Grid>

    <Grid size={12}>
      <BoxWithHeader title="Fotky vozu z nehody" mt={2}>
        <Grid container mt={3} spacing={3}>
          {accident?.media?.images && <AccidentsPhotos photos={accident?.media?.images} />}
        </Grid>
      </BoxWithHeader>
    </Grid>
  </Grid>
);
